import Presets from './presets.js';

export default Presets;